import CustomRepository from "./CustomRepository";
import CustomThemesRepository from "./CustomThemesRepository";
import UserRepository from "./UserRepository";
import AttempRepository from "./AttempRepository";

const repositories = {
    custom: CustomRepository,
    user: UserRepository,
    attempRepository: AttempRepository,
    //Otros
    customThemes: CustomThemesRepository
};

export const RepositoryFactory = {
    get: name => repositories[name]
};